export default "__VITE_ASSET__82a7b426__"